import { srConfig } from '@config';
import { usePrefersReducedMotion } from '@hooks';
import sr from '@utils/sr';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
  .about-aside {
    align-self: start;
    width: 100%;
    max-width: 300px;
    @media (max-width: 768px) {
      width: 85%;
      margin: 45px auto 0;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;
  overflow: hidden;
  border: 1px solid #315b61;
  border-radius: var(--border-radius);
  .about-photo {
    display: block;
    width: 100%;
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Java (8+)',
    'JavaScript (ES6+)',
    'C++ (14+)',
    'Python',
    'Linux/Unix',
    'Low-latency computing',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I’m driven by strategy, precision, and curiosity. Whether I’m deep in a poker hand,
              competing in esports, or untangling a complex coding problem. At the core, I’m a math
              enthusiast who loves turning ideas into systems that work.
            </p>

            <p>Here are a few technologies I have experience in:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>

          <div>
            <p>
              <br />
              Outside of work, you’ll find me exploring creative outlets like&nbsp;
              <a href="https://www.tiktok.com/@alanslovesyou">film</a>
              &nbsp;and&nbsp;
              <a href="https://www.instagram.com/alans.memoir">photography</a>, or competing in
              challenging games like chess, sudoku, and poker.
            </p>
          </div>
        </StyledText>

        <div className="about-aside">
          <StyledPic>
            <StaticImage
              className="about-photo"
              src="../../images/about-portrait.jpeg"
              width={600}
              quality={90}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Alans Fuentes outdoors in a suit"
            />
          </StyledPic>
        </div>
      </div>
    </StyledAboutSection>
  );
};

export default About;
